<div
  [class.active]="isOpenMenu"
  [class.disabled]="isDisabled"
  class="context-menu"
>
  <button
    [class.white]="color === 'white'"
    (click)="openMenu()"
    class="context-menu__btn"
  >
    <svg
      class="context-menu__btn-icon"
      viewBox="0 0 4 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.33464 3.33333C3.2513 3.33333 4.0013 2.58333 4.0013 1.66667C4.0013 0.75 3.2513 0 2.33464 0C1.41797 0 0.667969 0.75 0.667969 1.66667C0.667969 2.58333 1.41797 3.33333 2.33464 3.33333ZM2.33464 5C1.41797 5 0.667969 5.75 0.667969 6.66667C0.667969 7.58333 1.41797 8.33333 2.33464 8.33333C3.2513 8.33333 4.0013 7.58333 4.0013 6.66667C4.0013 5.75 3.2513 5 2.33464 5ZM2.33464 10C1.41797 10 0.667969 10.75 0.667969 11.6667C0.667969 12.5833 1.41797 13.3333 2.33464 13.3333C3.2513 13.3333 4.0013 12.5833 4.0013 11.6667C4.0013 10.75 3.2513 10 2.33464 10Z"
      />
    </svg>
  </button>
  <div [class.revert]="yPosition === 'top'" class="context-block">
    <div
      [class.left]="position === 'left'"
      [class.revert]="yPosition === 'top'"
      class="context-menu__body"
    >
      <ng-content></ng-content>
    </div>
  </div>
</div>
